export const SKELETONS = {
  input: {
    width: 20,
  },
};
